import React from 'react';
import { benefits } from '../data/content';
export function BenefitsSection() {
  return <section className="bg-brand-cream px-4 py-5 sm:px-6" aria-labelledby="benefits-heading" data-id="element-16" data-mp="cqmyoy61x8c">
      <h2 id="benefits-heading" className="mb-3 text-center font-heading text-xl uppercase leading-tight text-brand-navy sm:text-3xl" data-id="element-17" data-mp="3iqgapkibdji8">
        Ce qui va changer pour vous
      </h2>
      <div className="mx-auto grid max-w-xl gap-2 sm:grid-cols-2" data-id="element-18" data-mp="38ritl2n7ws99">
        {benefits.map(benefit => <article key={benefit.title} className="rounded-lg border border-brand-navy/10 bg-white p-3 shadow-sm" data-id="element-19" data-mp="3drdjp3z65dt9">
            <h3 className="mb-1 font-heading text-[13px] uppercase leading-tight text-brand-navy sm:text-[15px]" data-id="element-20" data-mp="2ztf7a44errge">
              {benefit.emoji} {benefit.title}
            </h3>
            {benefit.paragraphs.map(paragraph => <p key={paragraph} className="mb-1 text-[11px] font-medium leading-snug text-brand-ink/80 last:mb-0 sm:text-xs" data-id="element-21" data-mp="12ysgvxylk73n">
                {paragraph}
              </p>)}
          </article>)}
      </div>
    </section>;
}